/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import styles from './styles/LoadingScreen.css';

export const LoadingScreen = () => (
  <div className={styles.blackScreen}>
    <div className={styles.loadingContainer}>
      <div className={styles.loadingLogo}></div>
    </div>
  </div>
);

export default LoadingScreen;